<template>
  <div
    class="confirmation_popup_background"
    v-on:click.stop="$emit('hideConfirmationPopup')"
  >
    <div class="popup_body">
      <button class="close_button" v-on:click="$emit('hideConfirmationPopup')">
        &times;
      </button>
      <div v-if="isOwner">
        By proceeding, you confirm that the information provided is true and
        correct, and you, and each other owner, shareholder or director,
        provides us consent to conduct credit checks while we review your
        application.
      </div>
      <div v-if="!isOwner && isAutorized" class="confirmation_popup_autorised">
        <p>
          Please confirm that all your information is correct to the best of
          your knowledge. Once you click the button below, you will not be able
          to edit this.
        </p>
        <p>Please confirm that:</p>
        <p>
          i. you will provide the applicant(s) with a copy of the privacy
          declaration and that they have consented to Heartland Bank contacting
          them regarding this application; and
        </p>
        <p>
          ii. you have informed the applicant(s) that a credit check will be
          required and that they have consented to Heartland Bank conducting a
          credit check regarding this application.
        </p>
      </div>
      <div v-if="!isOwner && !isAutorized" class="confirmation_popup_autorised">
        <p>
          Please confirm that all your information is correct to the best of
          your knowledge. Once you click the button below, you will not be able
          to edit this.
        </p>
        <p>
          Please confirm that you will provide the applicant(s) with a copy of
          the privacy declaration and that and each owner, shareholder or
          director, has consented to Heartland Bank contacting them regarding
          this application.
        </p>
      </div>

      <div class="popup_buttons">
        <button
          class="cp_button"
          v-on:click="$emit('confirmSubmission')"
          :id="`tracking__${trackingCode}__confirm-pop-up__confirm`"
          data-test-id="confirm-submit-application"
        >
          Confirm and proceed
        </button>
        <button
          class="text_link"
          :id="`tracking__${trackingCode}__confirm-pop-up__return-edit`"
          v-on:click="$emit('hideConfirmationPopup')"
        >
          Return to edit
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isAutorized: function isAutorized() {
      return this.$parent.$parent.application.farmInfo.Authorised_Credit_Check;
    },
    isOwner: function isOwner() {
      return this.$parent.$parent.application.farmInfo.Applicant_Autorized;
    },
  },
  data() {
    return {
        trackingCode: window.trackingCode
    };
  },
  created() {
    let that = this;

    document.addEventListener("keyup", function (evt) {
      if (evt.keyCode === 27) {
        that.$emit("hideConfirmationPopup");
      }
    });
  },
};
</script>>